const jqService = ($window) => {
  if (!$window.$) {
    // If lodash is not available you can now provide a
    // mock service, try to load it from somewhere else,
    // redirect the user to a dedicated error page, ...
  }
  return $window.$.noConflict();
};

jqService.$inject = ['$window'];
export {jqService};


/** WEBPACK FOOTER **
 ** ./src/app/shared/services/jq.service.js
 **/